// Shared shipping rules. No pricing or cart submission is performed here.
window.HastaShipping = window.HastaShipping || {
  getWidth(widthValue) {
    if (typeof widthValue === 'number') {
      return Number.isFinite(widthValue) ? widthValue : 0;
    }
    if (typeof widthValue !== 'string') return 0;
    const normalized = widthValue.replace(',', '.').replace(/[–—]/g, '-').trim();
    const measurements = normalized.match(/\d+(?:\.\d+)?/g);
    if (!measurements || measurements.length === 0) return 0;
    const width = parseFloat(measurements[0]);
    return Number.isFinite(width) ? width : 0;
  },

  calculate(enabled, widthValue) {
    if (enabled !== true) return null;
    const width = this.getWidth(widthValue);
    if (width <= 0 || width < 110) return null;
    return width <= 260 ? 'Oversized_Goods' : 'Long_Goods';
  },

  getVariantData(form, sectionId) {
    const picker = document.querySelector(`variant-selects[data-section="${sectionId}"]`) ||
      document.querySelector(`variant-radios[data-section="${sectionId}"]`);
    if (!picker) return { hasShippingClass: false, width: 0 };
    try {
      const data = picker.querySelector('[data-product-variants]');
      if (!data) return { hasShippingClass: false, width: 0 };
      const variants = JSON.parse(data.textContent);
      const variantId = Number(new FormData(form).get('id'));
      const variant = variants.find(v => Number(v.id) === variantId);
      if (!variant) return { hasShippingClass: false, width: 0 };
      const optionNames = JSON.parse(picker.getAttribute('data-product-options') || '[]');
      const widthIndex = optionNames.findIndex(name =>
        String(name).trim().toLowerCase() === 'bredd'
      );
      return {
        hasShippingClass: variant.metafields?.custom?.shipping_class === true,
        width: widthIndex < 0 ? 0 : this.getWidth(variant[`option${widthIndex + 1}`])
      };
    } catch (e) {
      return { hasShippingClass: false, width: 0 };
    }
  },

  applyProperties(properties, enabled, widthValue) {
    delete properties._Oversized_Goods;
    delete properties._Long_Goods;
    const shippingClass = this.calculate(enabled, widthValue);
    if (shippingClass) properties[`_${shippingClass}`] = 'Yes';
    return properties;
  }
};

class ProductCustomizer {
  constructor(sectionId, productFormId) {
    this.sectionId = sectionId;
    this.productFormId = productFormId;
    this.isProcessingUpdate = false;
    this.isUpdatingPrice = false;
    this.countryCode = this.getCountryCode();
    this.currencySymbol = this.getCurrencySymbol();
    this.currencyCode = this.getCurrencyCode();
    this.sizeGroups = this.parseSizeGroups();
    this.priceList = this.parsePriceList();
    this.squarePrice = this.parseSquarePrice();
    this.singleSize = this.parseSingleSize();
    this.fixedWidth = this.parseFixedDimension('width');
    this.fixedHeight = this.parseFixedDimension('height');
    this.basePrice = this.getBasePrice();
    this.customizer = document.getElementById(`customizer-${this.sectionId}`) || 
                      document.querySelector('.product-customizer');
    this.init();
  }

  getCountryCode() {
    const customizerEl = document.querySelector('.product-customizer');
    return customizerEl?.getAttribute('data-country-code') || 'SE';
  }

  isEUCountry(countryCode) {
    // EU countries that should use FI pricing as fallback
    // Countries with their own prices: SE (Sweden), FI (Finland), GB (UK), NO (Norway)
    const euCountries = [
      'AT', // Austria
      'BE', // Belgium
      'BG', // Bulgaria
      'HR', // Croatia
      'CZ', // Czechia
      'DK', // Denmark
      'EE', // Estonia
      'ES', // Spain
      'FR', // France
      'DE', // Germany
      'GR', // Greece
      'HU', // Hungary
      'IE', // Ireland
      'IT', // Italy
      'LV', // Latvia
      'LT', // Lithuania
      'LU', // Luxembourg
      'MT', // Malta
      'NL', // Netherlands
      'PL', // Poland
      'PT', // Portugal
      'RO', // Romania
      'SK', // Slovakia
      'SI'  // Slovenia
    ];
    return euCountries.includes(countryCode);
  }

  getCurrencySymbol() {
    const customizerEl = document.querySelector('.product-customizer');
    return customizerEl?.getAttribute('data-currency-symbol') || '$';
  }

  getCurrencyCode() {
    const customizerEl = document.querySelector('.product-customizer');
    return customizerEl?.getAttribute('data-currency-code') || 'USD';
  }

  getFromPriceText(formattedPrice) {
    const customizerEl = document.querySelector('.product-customizer');
    const template = customizerEl?.getAttribute('data-from-price-template');

    if (!template) {
      return formattedPrice;
    }

    return template.replace('__PRICE__', formattedPrice);
  }

  getMinPrice() {
    const customizerEl = document.querySelector('.product-customizer');
    const minPriceAttr = customizerEl?.getAttribute('data-min-price');
    
    if (!minPriceAttr || minPriceAttr === 'null' || minPriceAttr === '' || minPriceAttr === '0') {
      return 0;
    }
    
    const minPrice = parseInt(minPriceAttr, 10);
    return isNaN(minPrice) ? 0 : minPrice;
  }

  hasValidPriceInformation() {
    // Check if valid price information exists for the current country/market
    // Returns false if calculated price is 0, indicating missing price data for this market
    
    // Calculate the actual total price with current inputs
    const prices = this.calculateAdditionalPrices();
    const hasCustomization = prices.total > 0;
    
    // Calculate total price using the same logic as updatePriceDisplay
    const minPrice = this.getMinPrice();
    const isUsingMinPriceFallback = minPrice > 0 && this.basePrice === minPrice;
    const totalPrice = (hasCustomization && isUsingMinPriceFallback) 
      ? prices.total 
      : this.basePrice + prices.total;
    
    // If total price is 0, either:
    // 1. Base price is missing/0 AND no additional pricing applies
    // 2. Price configuration exists but no data for current country
    // In both cases, prevent add to cart
    if (totalPrice <= 0) {
      return false;
    }
    
    return true;
  }

  init() {
    // console.log('📍 Market country code:', this.countryCode);
    // console.log('💱 Currency:', this.currencyCode, this.currencySymbol);
    this.setupEventListeners();
    this.updatePriceDisplay();
  }

  parseSizeGroups() {
    const customizerEl = document.querySelector('.product-customizer');
    if (!customizerEl) return null;
    
    const sizeGroupsAttr = customizerEl.getAttribute('data-size-groups');
    if (!sizeGroupsAttr || sizeGroupsAttr === 'null' || sizeGroupsAttr === '') {
      // console.warn('⚠️ No size groups found');
      return null;
    }
    
    try {
      const groups = JSON.parse(sizeGroupsAttr);
      // console.log('✅ Loaded size groups');
      return groups;
    } catch (e) {
      // console.error('❌ Error parsing size groups:', e);
      return null;
    }
  }

  parsePriceList() {
    const customizerEl = document.querySelector('.product-customizer');
    if (!customizerEl) return null;
    
    const priceListAttr = customizerEl.getAttribute('data-price-list');
    if (!priceListAttr || priceListAttr === 'null' || priceListAttr === '') {
      // console.warn('⚠️ No price list found');
      return null;
    }
    
    try {
      const priceList = JSON.parse(priceListAttr);
      // console.log('✅ Loaded price list');
      return priceList;
    } catch (e) {
      // console.error('❌ Error parsing price list:', e);
      return null;
    }
  }

  parseSquarePrice() {
    const customizerEl = document.querySelector('.product-customizer');
    if (!customizerEl) return null;
    
    const hasFabricPricing = customizerEl.getAttribute('data-has-fabric-pricing') === 'true';
    const squarePriceAttr = customizerEl.getAttribute('data-square-price');
    
    // console.log('🔍 parseSquarePrice - hasFabricPricing:', hasFabricPricing);
    // console.log('🔍 parseSquarePrice - squarePriceAttr:', squarePriceAttr);
    // console.log('🔍 parseSquarePrice - countryCode:', this.countryCode);
    
    if (!squarePriceAttr || squarePriceAttr === 'null' || squarePriceAttr === '') {
      // console.log('ℹ️ No square price configured');
      return null;
    }
    
    // If fabric_prices is not empty and square_price has content,
    // calculate based on market-specific pricing from dimensions
    if (hasFabricPricing) {
      try {
        const squarePriceData = JSON.parse(squarePriceAttr);
        // console.log('🔍 Parsed squarePriceData:', squarePriceData);
        
        // Structure: { "price": [{ "FI": 0.1, "SE": 10, "GB": 0.3 }] }
        if (squarePriceData && squarePriceData.price && Array.isArray(squarePriceData.price) && squarePriceData.price[0]) {
          let marketPrice = squarePriceData.price[0][this.countryCode];
          // console.log('🔍 marketPrice for', this.countryCode, ':', marketPrice);
          
          if (marketPrice !== undefined && marketPrice !== null) {
            // console.log('✅ Market-specific square pricing enabled:', marketPrice, this.countryCode, 'per m²');
            return marketPrice;
          } else if (this.isEUCountry(this.countryCode)) {
            // Fallback to Finland price for EU countries
            // console.log('🇪🇺 Country', this.countryCode, 'is in EU, checking for FI fallback...');
            const fiPrice = squarePriceData.price[0]['FI'];
            // console.log('🔍 FI price available:', fiPrice);
            if (fiPrice !== undefined && fiPrice !== null) {
              // console.log('✅ Using FI fallback price for EU country', this.countryCode, ':', fiPrice, 'per m²');
              return fiPrice;
            }
            // console.warn('⚠️ No FI fallback price available for EU country:', this.countryCode);
            return null;
          } else {
            // console.warn('⚠️ No price found for market:', this.countryCode, 'in fabric_prices. Available markets:', Object.keys(squarePriceData.price[0]));
            return null;
          }
        } else {
          // console.warn('⚠️ Invalid fabric_prices structure. Expected { "price": [{ "FI": 0.1, ... }] }, got:', squarePriceData);
          return null;
        }
      } catch (e) {
        // console.error('❌ Error parsing fabric square prices JSON:', e);
        // console.error('Raw attribute value:', squarePriceAttr);
        return null;
      }
    }
    
    // Fallback to simple numeric square price (legacy support)
    const squarePrice = parseFloat(squarePriceAttr);
    if (isNaN(squarePrice) || squarePrice <= 0) {
      // console.warn('⚠️ Invalid square price:', squarePriceAttr);
      return null;
    }
    
    // console.log('✅ Square pricing enabled:', squarePrice, 'per m²');
    return squarePrice;
  }

  parseSingleSize() {
    const customizerEl = document.querySelector('.product-customizer');
    if (!customizerEl) return null;
    
    const singleSizeAttr = customizerEl.getAttribute('data-single-size');
    
    if (!singleSizeAttr || singleSizeAttr === 'null' || singleSizeAttr === '') {
      // console.log('ℹ️ No single_size configured');
      return null;
    }
    
    const singleSize = parseFloat(singleSizeAttr);
    if (isNaN(singleSize) || singleSize <= 0) {
      // console.warn('⚠️ Invalid single_size:', singleSizeAttr);
      return null;
    }
    
    // console.log('📏 Single size configured:', singleSize, 'cm');
    return singleSize;
  }

  parseFixedDimension(dimension) {
    const customizerEl = document.querySelector('.product-customizer');
    if (!customizerEl) return null;
    
    const attrName = `data-fixed-${dimension}`;
    const fixedValue = customizerEl.getAttribute(attrName);
    
    if (!fixedValue || fixedValue === 'null' || fixedValue === '') {
      return null;
    }
    
    const value = parseFloat(fixedValue);
    if (isNaN(value) || value <= 0) {
      // console.warn(`⚠️ Invalid fixed ${dimension}:`, fixedValue);
      return null;
    }
    
    // console.log(`📌 Fixed ${dimension}:`, value, 'cm');
    return value;
  }

  getBasePrice() {
    // Get the base product price in cents
    const priceElement = document.querySelector('.price-item--regular');
    if (!priceElement) {
      // No price element found, use min_price if available
      return this.getMinPrice();
    }
    
    const priceText = priceElement.textContent.trim();
    // Remove currency symbols and parse
    const priceMatch = priceText.match(/[\d,.]+/);
    if (!priceMatch) {
      // No price found in element, use min_price if available
      return this.getMinPrice();
    }
    
    let priceStr = priceMatch[0];
    
    // Detect if comma or dot is the decimal separator
    const lastComma = priceStr.lastIndexOf(',');
    const lastDot = priceStr.lastIndexOf('.');
    
    // If both exist, the last one is the decimal separator
    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        // Comma is decimal: remove dots, replace comma with dot
        priceStr = priceStr.replace(/\./g, '').replace(',', '.');
      } else {
        // Dot is decimal: just remove commas
        priceStr = priceStr.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      // Only comma exists - check if it's a decimal separator
      const afterComma = priceStr.substring(lastComma + 1);
      if (afterComma.length === 2) {
        // Likely decimal separator (e.g., 70,95)
        priceStr = priceStr.replace(',', '.');
      } else {
        // Likely thousands separator (e.g., 1,000)
        priceStr = priceStr.replace(/,/g, '');
      }
    }
    // If only dot exists, it's already in correct format
    
    const price = parseFloat(priceStr);
    const priceInCents = Math.round(price * 100); // Convert to cents
    
    // If price is 0, use min_price if available
    if (priceInCents === 0) {
      return this.getMinPrice();
    }
    
    return priceInCents;
  }

  findPriceForMeasurement(measurement, groupType) {
    if (!this.sizeGroups || !this.sizeGroups[groupType]) {
      // console.warn(`⚠️ No size groups found for type: ${groupType}`);
      return 0;
    }
    
    if (!this.priceList) {
      // console.warn(`⚠️ No price list found`);
      return 0;
    }
    
    const groups = this.sizeGroups[groupType];
    
    // Step 1: Find the group code based on measurement
    let groupCode = null;
    for (let group of groups) {
      if (measurement >= group.min && measurement <= group.max) {
        groupCode = group.group;
        break;
      }
    }
    
    // If no exact match, find the nearest group
    if (!groupCode) {
      const sortedGroups = [...groups].sort((a, b) => a.min - b.min);
      
      if (measurement < sortedGroups[0].min) {
        groupCode = sortedGroups[0].group;
      } else if (measurement > sortedGroups[sortedGroups.length - 1].max) {
        groupCode = sortedGroups[sortedGroups.length - 1].group;
      }
    }
    
    if (!groupCode) {
      // console.warn(`⚠️ No group code found for ${groupType}: ${measurement}`);
      return 0;
    }
    
    // Step 2: Look up price for this group code in the price list
    const groupCodeLower = groupCode.toLowerCase();
    
    if (!this.priceList[groupCodeLower]) {
      // console.warn(`⚠️ No price entry found for group: ${groupCode}`);
      return 0;
    }
    
    // Price list structure: "x12": [{"SE": 135, "GB": 250, "FI": 90}]
    const priceEntry = this.priceList[groupCodeLower][0]; // First element contains market prices
    let price = priceEntry[this.countryCode];
    
    if (price === undefined) {
      // Check if this is an EU country and fallback to FI price
      if (this.isEUCountry(this.countryCode)) {
        price = priceEntry['FI'];
        if (price === undefined) {
          // console.warn(`⚠️ No FI fallback price found for ${groupCode} in EU market: ${this.countryCode}`);
          return 0;
        }
      } else {
        // console.warn(`⚠️ No price found for ${groupCode} in market: ${this.countryCode}`);
        return 0;
      }
    }
    
    // console.log(`💰 ${groupType} ${measurement} → ${groupCode} → ${price} ${this.countryCode}`);
    return price * 100; // Convert to cents
  }

  calculateAdditionalPrices() {
    const { widthInput, heightInput } = this.getInputFields();
    
    let widthPrice = 0;
    let heightPrice = 0;
    let squareMeterPrice = 0;
    let freightPrice = 0;
    let packingPrice = 0;
    let singleSizeUsed = null; // Track which dimension used single_size
    
    // Get width value - either from input or fixed dimension
    let width = this.fixedWidth || 0;
    if (widthInput && widthInput.value) {
      width = parseFloat(widthInput.value);
    }
    
    // Get height value - either from input or fixed dimension
    let height = this.fixedHeight || 0;
    if (heightInput && heightInput.value) {
      height = parseFloat(heightInput.value);
    }
    
    // console.log('💵 calculateAdditionalPrices - this.squarePrice:', this.squarePrice, 'width:', width, 'height:', height, 'singleSize:', this.singleSize);
    
    // Check if square pricing is enabled
    if (this.squarePrice !== null && this.squarePrice !== undefined) {
      // For products with only one customizable dimension, use single_size for the other
      if (this.singleSize && this.singleSize > 0) {
        // Determine which dimension is customizable
        const hasWidthInput = widthInput && !this.fixedWidth;
        const hasHeightInput = heightInput && !this.fixedHeight;
        
        if (hasWidthInput && !hasHeightInput && width > 0) {
          // Only width is customizable, use single_size for height
          height = this.singleSize;
          singleSizeUsed = 'height';
          // console.log(`📏 Using single_size for height: ${height}cm`);
        } else if (hasHeightInput && !hasWidthInput && height > 0) {
          // Only height is customizable, use single_size for width
          width = this.singleSize;
          singleSizeUsed = 'width';
          // console.log(`📏 Using single_size for width: ${width}cm`);
        }
      }
      
      // Square pricing mode: only calculate if BOTH dimensions are available
      if (width > 0 && height > 0) {
        // Calculate square meter price ONLY - no separate width/height/freight/packing charges
        // Convert cm to meters: width (cm) / 100 * height (cm) / 100 = area in m²
        const areaInSquareMeters = (width / 100) * (height / 100);
        squareMeterPrice = Math.round(areaInSquareMeters * this.squarePrice * 100); // Convert to cents
        // console.log(`📐 Square meter calculation: ${width}cm × ${height}cm = ${areaInSquareMeters.toFixed(2)}m² × ${this.squarePrice} = ${squareMeterPrice} cents`);
        // console.log('ℹ️ No separate width/height/freight/packing charges when using square pricing');
        if (singleSizeUsed) {
          // console.log(`✓ Single size (${this.singleSize}cm) used for ${singleSizeUsed}`);
        }
      } else {
        // console.log('⏳ Square pricing enabled but waiting for both dimensions (width:', width, 'height:', height, ')');
        // Return zero prices - don't calculate anything until both dimensions are entered
      }
    } else {
      // console.log('📝 Using traditional pricing with width/height/freight/packing charges');
      // Use traditional width/height pricing if square price is not set
      if (width > 0) {
        widthPrice = this.findPriceForMeasurement(width, 'width');
        freightPrice = this.findPriceForMeasurement(width, 'freight');
        packingPrice = this.findPriceForMeasurement(width, 'packing');
      }
      
      if (height > 0) {
        heightPrice = this.findPriceForMeasurement(height, 'length');
      }
    }
    
    return {
      width: widthPrice,
      height: heightPrice,
      squareMeter: squareMeterPrice,
      freight: freightPrice,
      packing: packingPrice,
      total: widthPrice + heightPrice + squareMeterPrice + freightPrice + packingPrice,
      singleSizeUsed: singleSizeUsed,
      actualWidth: width,
      actualHeight: height
    };
  }

  setupEventListeners() {
    this.setupRollerDirectionInputs();
    this.setupValidation();
    this.setupVariantChangeListener();
    this.setupCustomAddToCart();
    this.setupHelpTooltips();
    
    setTimeout(() => {
      this.validateInputs();
      this.updatePriceDisplay();
    }, 100);
  }

  refreshData() {
    this.sizeGroups = this.parseSizeGroups();
    this.priceList = this.parsePriceList();
    this.squarePrice = this.parseSquarePrice();
    this.singleSize = this.parseSingleSize();
    this.fixedWidth = this.parseFixedDimension('width');
    this.fixedHeight = this.parseFixedDimension('height');
    this.basePrice = this.getBasePrice();
    this.updatePriceDisplay();
  }

  setupRollerDirectionInputs() {
    // Use event delegation to handle clicks on dynamically loaded content
    document.addEventListener('click', (e) => {
      const container = e.target.closest('.field--image-radio');
      if (!container) return;
      
      const input = container.querySelector('input[type="radio"]');
      if (!input) return;
      
      // Check if this radio button belongs to this section's roller direction
      if (input.id === `under-rolled-${this.sectionId}` || input.id === `over-rolled-${this.sectionId}`) {
        e.preventDefault();
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Set cursor style for initial load
    this.updateRollerDirectionStyles();
  }

  setupHelpTooltips() {
    // Handle touch/click events for mobile tooltip toggle
    const helpIcons = document.querySelectorAll('.help-icon-wrapper');
    
    helpIcons.forEach(icon => {
      // Touch/click for mobile
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Close all other tooltips
        helpIcons.forEach(otherIcon => {
          if (otherIcon !== icon) {
            otherIcon.classList.remove('active');
          }
        });
        
        // Toggle current tooltip
        icon.classList.toggle('active');
      });
      
      // Keyboard support
      icon.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          icon.click();
        }
        if (e.key === 'Escape') {
          icon.classList.remove('active');
        }
      });
    });
    
    // Close tooltips when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.help-icon-wrapper')) {
        helpIcons.forEach(icon => icon.classList.remove('active'));
      }
    });
  }

  updateRollerDirectionStyles() {
    const input1 = document.getElementById('under-rolled-' + this.sectionId);
    const input2 = document.getElementById('over-rolled-' + this.sectionId);
    
    const container1 = input1 ? input1.closest('.field--image-radio') : null;
    const container2 = input2 ? input2.closest('.field--image-radio') : null;

    if (container1) {
      container1.style.cursor = 'pointer';
    }
    
    if (container2) {
      container2.style.cursor = 'pointer';
    }
  }

  getInputFields() {
    return {
      widthInput: document.getElementById(`max-width-${this.sectionId}`),
      heightInput: document.getElementById(`max-height-${this.sectionId}`),
      mountingHeightInput: document.getElementById(`mounting-height-${this.sectionId}`)
    };
  }

  getSubmitButtons() {
    // Try multiple selectors to find the add-to-cart button
    const selectors = [
      `#${this.productFormId} button[name="add"]`,  // Button inside form by ID
      `button[form="${this.productFormId}"][name="add"]`,  // Button with form attribute
      `button[name="add"]`,  // Any button with name="add" (fallback)
    ];
    
    for (const selector of selectors) {
      const buttons = document.querySelectorAll(selector);
      if (buttons.length > 0) {
        return Array.from(buttons);
      }
    }
    
    return [];
  }

  validateInputs() {
    try {
      const { widthInput, heightInput, mountingHeightInput } = this.getInputFields();
 
      const hasCustomizerFields = widthInput || heightInput || mountingHeightInput || this.fixedWidth || this.fixedHeight;
      const submitButtons = this.getSubmitButtons();
      
      // Check if we have buttons to work with
      if (!submitButtons || submitButtons.length === 0) {
        // console.error('❌ CRITICAL: No submit buttons found! Button state cannot be updated.');
        // console.error('   Product Form ID:', this.productFormId);
        // console.error('   Please check if the form exists in the DOM');
        return;
      }
      
      // If no customizer fields exist, check for valid price before enabling
      if (!hasCustomizerFields) {
        const hasPriceInfo = this.hasValidPriceInformation();
        submitButtons.forEach(btn => {
          if (hasPriceInfo) {
            btn.disabled = false;
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
          } else {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
            btn.setAttribute('aria-disabled', 'true');
          }
        });
        return;
      }
      
      let isValid = true;
      let allFieldsHaveValues = true;
    
    // Validate width if field exists
    if (widthInput) {
      const width = parseFloat(widthInput.value);
      const widthHasValue = widthInput.value && widthInput.value.trim() !== '';
      const minWidth = parseFloat(widthInput.getAttribute('min')) || 0;
      const maxWidth = parseFloat(widthInput.getAttribute('max')) || 999999;
      const widthValid = !isNaN(width) && width >= minWidth && width <= maxWidth && width > 0;
      
      if (!widthHasValue) {
        allFieldsHaveValues = false;
        widthInput.style.borderColor = '';
        widthInput.style.color = '';
      } else if (!widthValid) {
        isValid = false;
        widthInput.style.borderColor = 'rgb(255, 0, 0)';
        widthInput.style.color = 'rgb(255, 0, 0)';
      } else {
        widthInput.style.borderColor = '';
        widthInput.style.color = '';
      }
    } else if (this.fixedWidth) {
      // Fixed width is always valid
      // No input field to validate
    }
    
    // Validate height if field exists
    if (heightInput) {
      const height = parseFloat(heightInput.value);
      const heightHasValue = heightInput.value && heightInput.value.trim() !== '';
      const minHeight = parseFloat(heightInput.getAttribute('min')) || 0;
      const maxHeight = parseFloat(heightInput.getAttribute('max')) || 999999;
      const heightValid = !isNaN(height) && height >= minHeight && height <= maxHeight && height > 0;
      
      if (!heightHasValue) {
        allFieldsHaveValues = false;
        heightInput.style.borderColor = '';
        heightInput.style.color = '';
      } else if (!heightValid) {
        isValid = false;
        heightInput.style.borderColor = 'rgb(255, 0, 0)';
        heightInput.style.color = 'rgb(255, 0, 0)';
      } else {
        heightInput.style.borderColor = '';
        heightInput.style.color = '';
      }
    } else if (this.fixedHeight) {
      // Fixed height is always valid
      // No input field to validate
    }
    
    // Validate mounting height if field exists (accepts text or numbers)
    if (mountingHeightInput) {
      const mountingHasValue = mountingHeightInput.value && mountingHeightInput.value.trim() !== '';
      
      if (!mountingHasValue) {
        allFieldsHaveValues = false;
        mountingHeightInput.style.borderColor = '';
        mountingHeightInput.style.color = '';
      } else {
        // Valid if any value is provided (text or number)
        mountingHeightInput.style.borderColor = '';
        mountingHeightInput.style.color = '';
      }
    }
    
    // If we have fixed dimensions and square pricing, consider them as having values
    if (this.squarePrice) {
      if (this.fixedWidth || widthInput?.value) {
        if (this.fixedHeight || heightInput?.value) {
          // Both dimensions are available (either input or fixed)
          allFieldsHaveValues = true;
        }
      }
    }
    
    // Check if valid price information exists
    const hasPriceInfo = this.hasValidPriceInformation();
    
    const shouldDisable = !isValid || !allFieldsHaveValues || !hasPriceInfo;
    
    submitButtons.forEach((btn, index) => {
      if (shouldDisable) {
        btn.disabled = true;
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });
    } catch (error) {
      // console.error('❌ ERROR in validateInputs:', error);
      // console.error('Error stack:', error.stack);
    }
  }

  setupValidation() {
    const inputHandler = (e) => {
      if (this.isCustomizerInput(e.target)) {
        this.validateInputs();
        this.updatePriceDisplay();
      }
    };
    
    const changeHandler = (e) => {
      if (this.isCustomizerInput(e.target)) {
        this.validateInputs();
        this.updatePriceDisplay();
      }
    };
    
    document.addEventListener('input', inputHandler);
    document.addEventListener('change', changeHandler);
    
    this.inputHandler = inputHandler;
    this.changeHandler = changeHandler;
  }

  isCustomizerInput(element) {
    if (!element || element.tagName !== 'INPUT') return false;
    
    const id = element.id;
    return id === `max-width-${this.sectionId}` ||
           id === `max-height-${this.sectionId}` ||
           id === `mounting-height-${this.sectionId}`;
  }

  setupVariantChangeListener() {
    const variantSwitcher = document.querySelector(`variant-radios[data-section="${this.sectionId}"]`) || 
                           document.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
    
    if (variantSwitcher) {
      variantSwitcher.addEventListener('change', () => {
        setTimeout(() => {
          this.refreshData();
          this.updateRollerDirectionStyles();
          this.validateInputs();
          this.updatePriceDisplay();
        }, 150);
      });
    }
    
    const customizerElement = document.getElementById(`customizer-${this.sectionId}`);
    if (customizerElement) {
      this.mutationObserver = new MutationObserver((mutations) => {
        if (this.isProcessingUpdate) return;
        
        const hasSignificantChange = mutations.some(mutation => {
          if (mutation.target.id && mutation.target.id.includes('pricing-breakdown')) {
            return false;
          }
          if (mutation.target.type === 'hidden' || 
              mutation.target.id && mutation.target.id.includes('custom-')) {
            return false;
          }
          if (mutation.target.classList && 
              (mutation.target.classList.contains('price-item') || 
               mutation.target.classList.contains('price'))) {
            return false;
          }
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const hasCustomizerChange = Array.from(mutation.addedNodes).some(node => 
              node.id && node.id.includes('customizer')
            );
            return hasCustomizerChange;
          }
          return false;
        });
        
        if (hasSignificantChange) {
          this.isProcessingUpdate = true;
          setTimeout(() => {
            this.refreshData();
            this.updateRollerDirectionStyles();
            this.validateInputs();
            this.updatePriceDisplay();
            this.isProcessingUpdate = false;
          }, 100);
        }
      });
      
      this.mutationObserver.observe(customizerElement.parentElement || customizerElement, {
        childList: true,
        subtree: true
      });
    }
  }

  updatePriceDisplay() {
    if (this.isUpdatingPrice) return;
    // Allow price display if either size groups or square pricing is configured
    if (!this.sizeGroups && !this.squarePrice) return;
    
    this.isUpdatingPrice = true;
    const prices = this.calculateAdditionalPrices();
    
    // Check if user has entered any customization
    const hasCustomization = prices.total > 0;
    
    // Calculate total price:
    // - If min_price is being used as basePrice (fallback for 0-price products),
    //   only use the calculated custom price when customization is done
    // - Otherwise, add the base price to the custom price
    const minPrice = this.getMinPrice();
    const isUsingMinPriceFallback = minPrice > 0 && this.basePrice === minPrice;
    const totalPrice = (hasCustomization && isUsingMinPriceFallback) 
      ? prices.total 
      : this.basePrice + prices.total;
    
    // Update all price displays on the page
    const priceElements = document.querySelectorAll(`#price-${this.sectionId} .price-item--regular`);
    priceElements.forEach(el => {
      const formattedPrice = this.formatPrice(totalPrice);
      // Show "From [price]" when displaying initial min_price with no customization
      el.textContent = hasCustomization ? formattedPrice : this.getFromPriceText(formattedPrice);
    });
    
    // Update hidden form fields for line item properties
    this.updatePriceProperties(prices, totalPrice);
    
    // this.updatePricingBreakdown(prices);
    this.isUpdatingPrice = false;
    
    // Re-validate button state after price update
    this.validateInputs();
  }

  updatePriceProperties(prices, totalPrice) {
    // Update hidden fields that will be submitted as line item properties
    // Use standard decimal format (not locale-formatted) for cart storage
    const setFieldValue = (id, value) => {
      const field = document.getElementById(`${id}-${this.sectionId}`);
      if (field) {
        // Store price in standard decimal format for cart (e.g., "100.50")
        const cartValue = value ? this.formatPriceForCart(value) : '';
        field.value = cartValue;
        // console.log(`📝 Set ${id}:`, cartValue, `(${value} cents)`, `(Field: ${field.id})`);
      } else {
        // console.warn(`⚠️ Field not found: ${id}-${this.sectionId}`);
      }
    };
    
    // console.log('💰 Updating price properties');
    // console.log('   Total:', totalPrice, 'cents');
    // console.log('   Display format:', this.formatPrice(totalPrice));
    // console.log('   Cart storage format:', this.formatPriceForCart(totalPrice), this.currencyCode);
    setFieldValue('custom-total-price', totalPrice);
    setFieldValue('custom-width-price', prices.width);
    setFieldValue('custom-length-price', prices.height);
    setFieldValue('custom-square-meter-price', prices.squareMeter);
    setFieldValue('custom-freight-price', prices.freight);
    setFieldValue('custom-packing-price', prices.packing);
    setFieldValue('custom-base-price', this.basePrice);
    
    // Handle single_size usage
    if (prices.singleSizeUsed) {
      const singleSizeInfo = `${prices.singleSizeUsed}: ${this.singleSize}cm`;
      const field = document.getElementById(`custom-single-size-used-${this.sectionId}`);
      if (field) {
        field.value = singleSizeInfo;
        // console.log(`📏 Set single-size-used: ${singleSizeInfo}`);
      }
      
      // Also set the dimension property that was calculated from single_size
      // so it appears in cart line item properties
      this.setSingleSizeDimensionProperty(prices.singleSizeUsed, prices.actualWidth, prices.actualHeight);
    } else {
      // Clear the field if not using single size
      const field = document.getElementById(`custom-single-size-used-${this.sectionId}`);
      if (field) {
        field.value = '';
      }
    }
  }
  
  setSingleSizeDimensionProperty(dimensionUsed, actualWidth, actualHeight) {
    // Dynamically set or update hidden field for the dimension calculated from single_size
    // Only add if it's not already set by fixed_width or fixed_height in Liquid
    const form = document.getElementById(this.productFormId);
    if (!form) return;
    
    if (dimensionUsed === 'width') {
      // Width was calculated from single_size
      // Only add if it's not a fixed_width (which would already be added by Liquid)
      if (!this.fixedWidth) {
        let field = form.querySelector(`input[name="properties[Width (cm)]"]`);
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'properties[Width (cm)]';
          form.appendChild(field);
        }
        field.value = actualWidth;
        // console.log(`📏 Set Width property from single_size: ${actualWidth}cm`);
      } else {
        // console.log(`ℹ️ Width already set as fixed_width, skipping single_size property`);
      }
    } else if (dimensionUsed === 'height') {
      // Height was calculated from single_size
      // Only add if it's not a fixed_height (which would already be added by Liquid)
      if (!this.fixedHeight) {
        let field = form.querySelector(`input[name="properties[Height (cm)]"]`);
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'properties[Height (cm)]';
          form.appendChild(field);
        }
        field.value = actualHeight;
        // console.log(`📏 Set Height property from single_size: ${actualHeight}cm`);
      } else {
        // console.log(`ℹ️ Height already set as fixed_height, skipping single_size property`);
      }
    }
  }

  updatePricingBreakdown(prices) {
    const breakdownEl = document.getElementById(`pricing-breakdown-${this.sectionId}`);
    if (!breakdownEl) return;
    
    const { widthInput, heightInput } = this.getInputFields();
    const hasValues = (widthInput && widthInput.value) || (heightInput && heightInput.value) || this.fixedWidth || this.fixedHeight;
    
    if (!hasValues || prices.total === 0) {
      breakdownEl.innerHTML = '';
      return;
    }
    let html = '<div style="font-size: 0.875rem; color: #6b7280; margin-top: 0.5rem;">';
    html += '<strong>Additional charges:</strong><ul style="list-style: none; padding-left: 0; margin: 0.5rem 0;">';
    
    // Show square meter price if calculated
    if (prices.squareMeter > 0) {
      const width = this.fixedWidth || (widthInput ? parseFloat(widthInput.value) : 0);
      const height = this.fixedHeight || (heightInput ? parseFloat(heightInput.value) : 0);
      const areaInSquareMeters = (width / 100) * (height / 100);
      
      let dimensionStr = '';
      if (this.fixedWidth && !this.fixedHeight) {
        dimensionStr = ` (${width}cm fixed × ${height}cm)`;
      } else if (!this.fixedWidth && this.fixedHeight) {
        dimensionStr = ` (${width}cm × ${height}cm fixed)`;
      } else if (this.fixedWidth && this.fixedHeight) {
        dimensionStr = ` (${width}cm × ${height}cm fixed)`;
      } else {
        dimensionStr = ` (${width}cm × ${height}cm)`;
      }
      
      html += `<li>Square meter charge${dimensionStr} = ${areaInSquareMeters.toFixed(2)} m²: ${this.formatPrice(prices.squareMeter)}</li>`;
    } else {
      // Show traditional width/height charges if not using square pricing
      if (prices.width > 0) {
        html += `<li>Width charge: ${this.formatPrice(prices.width)}</li>`;
      }
      if (prices.height > 0) {
        html += `<li>Length charge: ${this.formatPrice(prices.height)}</li>`;
      }
    }
    
    if (prices.freight > 0) {
      html += `<li>Freight: ${this.formatPrice(prices.freight)}</li>`;
    }
    if (prices.packing > 0) {
      html += `<li>Packing: ${this.formatPrice(prices.packing)}</li>`;
    }
    
    html += '</ul></div>';
    breakdownEl.innerHTML = html;
  }

  formatPrice(priceInCents) {
    // Use Shopify's money formatting if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      const moneyFormat = window.theme?.moneyFormat || '{{amount}}';
      let formattedPrice = Shopify.formatMoney(priceInCents, moneyFormat);
      
      // Remove trailing currency symbols to avoid duplication (e.g., "kr", "kr.", etc.)
      formattedPrice = formattedPrice.replace(/\s*(kr\.?|£|€|\$)\s*$/i, '').trim();
      
      // Append currency code
      return `${formattedPrice} ${this.currencyCode}`;
    }
    
    // Fallback: amount + currency code (no symbol to avoid duplication)
    const price = priceInCents / 100;
    return `${price.toFixed(2)} ${this.currencyCode}`;
  }

  formatPriceForCart(priceInCents) {
    // Format price for cart storage in a consistent, parsable format
    // Returns decimal format with dot separator (e.g., "100.50")
    // This format is consistent across all locales and can be parsed by cart transforms
    const price = priceInCents / 100;
    return price.toFixed(2);
  }

  setupCustomAddToCart() {
    // Find the product form
    const productForm = document.getElementById(this.productFormId);
    if (!productForm) return;

    // Check if customizer is active (has size groups or square pricing)
    if (!this.sizeGroups && !this.squarePrice) return;

    // Get the product-form custom element
    const productFormElement = productForm.closest('product-form');
    if (!productFormElement) return;

    // Override the form submission with our custom handler
    productForm.addEventListener('submit', (e) => {
      // Only intercept if we have customizer fields with values (or fixed dimensions)
      const { widthInput, heightInput } = this.getInputFields();
      const hasCustomizerValues = (widthInput && widthInput.value) || (heightInput && heightInput.value) || this.fixedWidth || this.fixedHeight;
      
      // console.log('🎯 Form submit intercepted. Has customizer values:', hasCustomizerValues);
      
      if (!hasCustomizerValues) {
        // console.log('⏩ No customizer values - letting default handler process');
        return; // Let default handler work if no custom values
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      // console.log('✋ Preventing default, using custom handler');
      this.handleCustomAddToCart(productForm, productFormElement);
    }, true); // Use capture phase to intercept before product-form element
  }

  /**
   * Convert the product width to the width used for shipping classification.
   *
   * Only width is used. Height never affects the shipping class.
   * For ranges such as "130-260 cm", the first/shortest width is used.
   */
  getShippingWidth(widthValue) {
    return window.HastaShipping.getWidth(widthValue);
  }

  calculateShippingClass(widthValue) {
    return window.HastaShipping.calculate(true, widthValue);
  }

  checkVariantShippingClass(variantSelectsEl, variantId) {
    if (!variantSelectsEl) return false;
    try {
      const variantsData = variantSelectsEl.querySelector('[data-product-variants]');
      if (!variantsData) return false;
      const variants = JSON.parse(variantsData.textContent);
      const variant = variants.find(v => Number(v.id) === Number(variantId));
      return variant?.metafields?.custom?.shipping_class === true;
    } catch (e) {
      return false;
    }
  }

  getEffectiveShippingWidth(form) {
    const { widthInput } = this.getInputFields();
    const customizerWidth = this.fixedWidth || (widthInput ? widthInput.value : 0);
    const width = this.getShippingWidth(customizerWidth);
    if (width > 0) return width;
    return window.HastaShipping.getVariantData(form, this.sectionId).width;
  }

  async handleCustomAddToCart(form, productFormElement) {
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

    // Verify price is valid before proceeding
    if (!this.hasValidPriceInformation()) {
      this.handleCartError(productFormElement, 'Price information not available for this market.');
      return;
    }

    // Show loading state
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    const loadingOverlay = productFormElement.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    // Clear any existing error messages
    this.handleCartError(productFormElement);

    try {
      // Prepare form data
      const formData = new FormData(form);
      
      // Build the cart add request
      const cartData = {
        items: [{
          id: parseInt(formData.get('id')),
          quantity: parseInt(formData.get('quantity')) || 1,
          properties: {}
        }]
      };

      
      // Add all properties including custom prices
for (let [key, value] of formData.entries()) {
  if (key.startsWith('properties[')) {
    const propertyMatch =
      key.match(/properties\[(.+)\]/);

    if (!propertyMatch) {
      continue;
    }

    const propKey =
      propertyMatch[1];

    if (
      value &&
      String(value).trim() !== ''
    ) {
      cartData.items[0].properties[propKey] =
        value;
    }
  }
}

// Recalculate shipping only. All custom price properties remain untouched.
const variantData = window.HastaShipping.getVariantData(form, this.sectionId);
const widthValue = this.getEffectiveShippingWidth(form);
window.HastaShipping.applyProperties(
  cartData.items[0].properties,
  variantData.hasShippingClass,
  widthValue
);

      // Debug: Log what we're sending
      // console.log('🛒 Adding to cart with properties:', cartData.items[0].properties);
      // console.log('📊 Custom Total Price:', cartData.items[0].properties._Custom_Total_Price || '(not set)');
      
      // Verify custom price exists before sending
      if (!cartData.items[0].properties._Custom_Total_Price) {
        // console.warn('⚠️ Warning: Adding to cart without custom total price!');
        // console.warn('   This means the cart transform won\'t apply custom pricing.');
        // console.warn('   Hidden field value:', document.getElementById(`custom-total-price-${this.sectionId}`)?.value);
      }

      // Make the cart add request
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(cartData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || 'Failed to add to cart');
      }

      // Show success notification
      this.showCartNotification(result.items[0]);

      // Dispatch custom event for cart updates
      const event = new CustomEvent('ajaxProduct:added');
      document.dispatchEvent(event);

      // Reset quantity if needed
      const hiddenQuantity = document.querySelector('[type=hidden][name=quantity]');
      if (hiddenQuantity) hiddenQuantity.value = 1;

    } catch (error) {
      // console.error('Custom add to cart error:', error);
      this.handleCartError(productFormElement, error.message);
    } finally {
      // Remove loading state
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
    }
  }

  handleCartError(productFormElement, errorMessage = false) {
    const errorWrapper = productFormElement.querySelector('.product-form__error-message-wrapper');
    if (!errorWrapper) return;

    const errorMessageEl = errorWrapper.querySelector('.product-form__error-message');
    
    if (errorMessage) {
      errorWrapper.removeAttribute('hidden');
      if (errorMessageEl) errorMessageEl.textContent = errorMessage;
    } else {
      errorWrapper.setAttribute('hidden', '');
      if (errorMessageEl) errorMessageEl.textContent = '';
    }
  }

  showCartNotification(item) {
    const cartNotification = document.getElementById('cart-notification');
    if (!cartNotification) return;

    const notificationTemplate = document.importNode(cartNotification.content, true);
    
    // Set title
    const titleEl = notificationTemplate.querySelector('[data-notification-title]');
    if (titleEl && window.variantStrings?.itemAdded) {
      titleEl.textContent = window.variantStrings.itemAdded;
    }

    // Create notification item
    const notificationItem = this.createCartNotificationItem(item);
    const itemsContainer = notificationTemplate.querySelector('[data-items]');
    if (itemsContainer) {
      itemsContainer.appendChild(notificationItem);
    }

    // Remove existing notification if present
    const existingNotification = document.querySelector('.cart-notification');
    if (existingNotification) existingNotification.remove();

    // Add new notification to DOM
    document.body.appendChild(notificationTemplate);

    // Show notification with animation
    const notification = document.querySelector('.cart-notification');
    if (notification) {
      notification.setAttribute('tabindex', '-1');
      notification.focus();

      const closeBtn = notification.querySelector('.notification-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          notification.classList.remove('anim-in');
        });
      }

      setTimeout(() => {
        notification.classList.add('anim-in');
      }, 50);
    }
  }

  createCartNotificationItem(product) {
    const cartNotificationItem = document.getElementById('cart-notification-item');
    if (!cartNotificationItem) return document.createElement('div');

    const template = document.importNode(cartNotificationItem.content, true);

    // Set image
    if (product.image) {
      const filename = product.image.split('/').pop();
      const lastDotIndex = filename.lastIndexOf('.');
      const newFilename = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
      const imageUrl = product.image.replace(filename, newFilename);
      
      const imageEl = template.querySelector('.notification-item-image');
      if (imageEl) {
        imageEl.setAttribute('src', imageUrl);
        imageEl.classList.remove('hide');
      }
    }

    // Set title
    const titleEl = template.querySelector('.notification-item-title');
    if (titleEl) {
      titleEl.textContent = product.product_title;
    }

    // Add options
    const detailsContainer = template.querySelector('.notification-item-details');
    if (detailsContainer && product.options_with_values) {
      product.options_with_values.forEach(option => {
        const row = document.createElement('dl');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = option.name + ': ';
        dd.textContent = option.value;
        row.appendChild(dt);
        row.appendChild(dd);
        detailsContainer.appendChild(row);
      });
    }

    // Add properties (excluding internal ones starting with _)
    if (detailsContainer && product.properties) {
      Object.entries(product.properties).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) {
          const row = document.createElement('dl');
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = key + ': ';
          dd.textContent = value;
          row.appendChild(dt);
          row.appendChild(dd);
          detailsContainer.appendChild(row);
        }
      });
    }

    return template;
  }
}

window.initProductCustomizer = function(sectionId, productFormId) {
  if (typeof ProductCustomizer === 'undefined') return;
  
  const customizerElement = document.getElementById(`customizer-${sectionId}`) ||
                            document.querySelector('.product-customizer');
  
  if (!customizerElement) return;
  
  if (!window.customizerInstances) {
    window.customizerInstances = {};
  }
  
  if (window.customizerInstances[sectionId]) {
    const oldInstance = window.customizerInstances[sectionId];
    if (oldInstance.mutationObserver) {
      oldInstance.mutationObserver.disconnect();
    }
  }
  
  try {
    window.customizerInstances[sectionId] = new ProductCustomizer(sectionId, productFormId);
  } catch (error) {
    // console.error('Error creating ProductCustomizer:', error);
  }
};